import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 5000,
})

service.interceptors.request.use(
  config => {
    config.headers['X-SP-Id'] = process.env.API_ID
    config.headers['X-SP-Key'] = process.env.API_KEY
    config.headers['X-SP-Lang'] = localStorage.getItem('lang') == 'zh' ? 'ZH' : 'ES'
    config.headers['X-SP-Local'] = localStorage.getItem('lang') == 'zh' ? 'CN' : 'ES'
    return config
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(response => {
  if (response.data && response.data.code == 0) {
    return Promise.resolve(response.data.result)
  } else {
    Message({
      message: response.data.msg || response.data.message || 'Error',
      type: 'error',
      duration: 6000,
      showClose: true,
    })
    return Promise.reject({})
  }
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js